import { Injectable } from '@angular/core';
import { CounterWidgetDataEntryDto } from '@osos/shared/api';
import { CounterWidgetDataEntryPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable({
  providedIn: 'root',
})
export class CounterEntryParserV1Service extends ParserBase<
  CounterWidgetDataEntryDto,
  CounterWidgetDataEntryPresenterModel
> {
  constructor() {
    super(CounterWidgetDataEntryDto, CounterWidgetDataEntryPresenterModel, 1);
  }
  getPresenterModel(
    model: Partial<CounterWidgetDataEntryDto>,
  ): CounterWidgetDataEntryPresenterModel {
    return {
      specificationVersion: this.version,
      id: model.id,
      dataEntity: model.dataEntity,
      query: model.value?.query,
      viewDataEntity: model.value?.dataEntity,
      displayOrder: model.value?.displayOrder,
      icon: model.value?.icon,
      moduleId: model.value?.moduleId,
      view: model.value?.view,
      name: model.value?.name,
      description: model.value?.description,

      moduleName: model.moduleName,
      viewName: model.viewName,
      state: model.state,
      entityVersion: model.entityVersion ?? 0,
    };
  }
  getDataModel(
    presenter: CounterWidgetDataEntryPresenterModel,
  ): CounterWidgetDataEntryDto {
    const model = {
      specificationVersion: this.version,
      value: {
        dataEntity: presenter.viewDataEntity,
        description: presenter.description,
        displayOrder: presenter.displayOrder,
        icon: presenter.icon,
        moduleId: presenter.moduleId,
        name: presenter.name,
        view: presenter.view,
        query: presenter.query,
      },
    } as CounterWidgetDataEntryDto;

    return model;
  }
}
